import Axis from 'util/table/Axis';

export class TableError extends Error {
    constructor(message) {
        super(message);
        this.name = "TableError";
    }
}

/**
 * Class representing a table
 */
export default class Table {
    /**
     * Instances a table
     * @param {object} obj - object representing a table
     * @param {number} obj.dimension - the dimension of the table
     * @param {Axis} [obj.xAxis] - x axis data
     * @param {Axis} [obj.yAxis] - y axis data
     * @param {Axis} obj.dataAxis - z axis data
     */
    constructor({dimension, xAxis, yAxis, dataAxis, ...metaData}) {
        if (dimension === undefined || isNaN(parseFloat(dimension))) throw new TableError("Must have a valid dimension");
        dimension = parseFloat(dimension);
        
        if (!dataAxis) throw new TableError("Must have a dataAxis");

        if (xAxis && dimension >= 2 && xAxis.matrix.shape.n !== dataAxis.matrix.shape.n)
            throw new TableError("xAxis length doesn't match dataAxis width");
        if (yAxis && dimension >= 3 && yAxis.matrix.shape.n !== dataAxis.matrix.shape.m)
            throw new TableError("yAxis length doesn't match dataAxis height");

        Object.assign(this, {dimension, xAxis, yAxis, dataAxis, ...metaData}); //assign given obj to new obj
        Object.seal(this); //stop additional fields from being added to new obj
    }
}